module.exports = __webpack_public_path__ + "static/img/ftlanguage.797acdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftlanguage.png
// module id = Irt6
// module chunks = 0